
<!-- fullscreen: a Vuetify dialog (it takes care of layering and styling); else over the positioned parent -->
<component :is="fullscreen ? 'v-dialog' : 'div'" v-bind="wrapper" v-on="wrapperEvents">
    <div class="lightbox" :class="{ 'lightbox-full': fullscreen }">
        <div v-if="!fullscreen" class="image-overlay" :style="box"></div>

        <div class="image-zoom" :style="box">
            <div class="lightbox-buttons">
                <v-btn fab color="primary" small @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-btn fab color="primary" small class="mt-3" @click="onMax">
                    <v-icon>mdi-arrow-expand-all</v-icon>
                </v-btn>

                <v-btn fab color="primary" small class="mt-3" @click="onDownload">
                    <v-icon>mdi-download</v-icon>
                </v-btn>
            </div>
            <v-carousel
                hide-delimiters
                show-arrows-on-hover
                :height="fullscreen ? '100vh' : height + 10"
                :class="{ 'mt-5': !fullscreen }"
                :value="position"
                @change="$emit('update:position', $event)"
            >
                <v-carousel-item v-for="image in images" :key="image.id">
                    <img-image :id="image.id" :item="image" :image="true" :fill="fullscreen" />
                </v-carousel-item>
            </v-carousel>
        </div>
    </div>
</component>
